exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media screen and (min-width:40em){aside.sidebar>*{flex:calc(100% / 3 - 1rem);margin:.5rem}aside.sidebar>.trending,aside.sidebar>.videos{flex:calc(100% / 2 - 1rem)}aside{margin-bottom:1rem}h1{padding:1rem 0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/article/medium-up.css
// module id = 59
// module chunks = 4